<template>
<div>
    <div class="content">
        <div class="cont-list">
            <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
            <span class="masge">当前共有{{ total }}个产品注册证</span>
        </div>
        <div class="header">
            <div class="left">
                <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
                <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
                    删除
                </el-button>
            </div>
            <div class="right">
                <div class="search">
                    <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
                        <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
                    </el-input>
                    <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
                </div>
                <span v-preventReClick @click="reset">重置</span>
            </div>
        </div>

        <div style="margin-bottom: 10px">
          <el-tabs v-model="query.sourceType" @tab-click="tabClick" stretch style="width: 30%;">
            <el-tab-pane v-for="item in systemType" :key="item.id" :name="item.id">
              <template slot="label">
                <!--  -->
                <el-badge class="item">
                  <span style="margin: 0 10px"> {{ item.name }} </span>
                </el-badge>
              </template>
            </el-tab-pane>
          </el-tabs>
        </div>

        <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <template slot="empty">
                <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                    <img src="../../../../assets/noData.png" width="240" height="240" />
                    <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                    <div class="empty-rest" @click="reset">恢复默认</div>
                </div>
            </template>
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
            <!-- <el-table-column prop="sourceType" label="注册证分类" min-width="180"></el-table-column> -->
             <el-table-column prop="no" v-if="query.sourceType==1" label="注册证号" min-width="180">
                <template slot-scope="scope">
                    <span>
                        <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
                    </span>
                </template>
             </el-table-column>
            <el-table-column prop="no" v-else label="批准文号" min-width="180">
                <template slot-scope="scope">
                    <span>
                        <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="注册证名称" min-width="100">
            </el-table-column>
            <el-table-column prop="productCommonName" label="产品通用名" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{ scope.row.productCommonName?scope.row.productCommonName:'-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="effectDate" label="生效日期" width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{ scope.row.effectDate?parseTime(new Date(scope.row.effectDate), "{y}-{m}-{d}"):'-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="invalidDate" label="失效日期" width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{ scope.row.invalidDate?parseTime(new Date(scope.row.invalidDate), "{y}-{m}-{d}"):'-' }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column label="审批状态" width="80" align="center" prop="stateName" /> -->
            <el-table-column prop="createdTime" label="创建时间" min-width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ parseTime(new Date(scope.row.createdTime)) }}
                </template>
            </el-table-column>
            <el-table-column prop="name" label="是否换新证" min-width="100">
                <template slot-scope="scope">
                    <span>{{ scope.row.isNew == 1 ? "是" : "否" }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="operation" fixed="right" label="操作" width="180">
                <template slot-scope="scope">
                    <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
                    <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
                    <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="title + '产品注册证'" :visible.sync="open" :center="true" width="900px" :before-close="cancel" :close-on-click-modal="false">
            <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="注册证分类" prop="sourceType">
                            <el-select v-model="form.sourceType" placeholder="请选择注册证分类" style="width: 100%" clearable  >
                                <template v-for="item in WarehouseTypeOptions">
                                <el-option :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="form.sourceType==2?'批准文号':'注册证号'" prop="no">
                            <el-input v-model="form.no" :disabled="!editMode" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="注册证名称" prop="name">
                            <el-input v-model="form.name" :disabled="!editMode" placeholder="请填写注册证名称"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="产品通用名" prop="productCommonName">
                            <el-input v-model="form.productCommonName" :disabled="!editMode" placeholder="请填写产品通用名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="生产厂家" prop="manufacturerId">
                            <el-select v-model="form.manufacturerName" :disabled="!editMode" placeholder="请选择生产厂家" :filter-method="(keyWord) => getManufacturers(keyWord, 1)" filterable @change="manufacturerChange" style="width:100%">
                                <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="售后代理商" >
                        <el-select v-model="form.agentName" :disabled="!editMode" placeholder="请选择售后代理商" :filter-method="(keyWord) => getManufacturers(keyWord, 1)" filterable @change="AgentNameChange" style="width:100%">
                            <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                     <el-col :span="12">
                         <el-form-item label="注册备案人" prop="registrantUser">
                            <el-select v-model="form.registrantUserName" :disabled="!editMode" placeholder="请选择注册备案人" :filter-method="(keyWord) => getManufacturers(keyWord, 1)" filterable @change="registrantUserChange" style="width:100%">
                                <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                     </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="对应经营范围" prop="manageRangeIds">
                            <el-select v-model="form.manageRangeIds" class="manageRange" :disabled="!editMode" placeholder="请选择经营范围" :filter-method="getManageRanges" filterable multiple @change="manageRangeChange" style="width:100%">
                                <el-option v-for="item in STATIC_ManageRanges" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="10">
                        <el-form-item label="生效日期" prop="effectDate">
                            <el-date-picker v-model="form.effectDate" :disabled="!editMode" type="date" placeholder="请选择生效日期" style="width:100%"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="失效日期" prop="invalidDate">
                            <el-date-picker v-model="form.invalidDate" :disabled="!editMode" type="date" placeholder="选择失效日期" @change="invalidDateEvt" style="width:100%"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item style="margin-left:10px;margin-top: 30px;">
                            <el-checkbox v-model="form.longTime" @change="longTimeEvt">长期</el-checkbox>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div style="margin:0 0 12px 10px" v-if="editMode">
                    <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
                    <el-button class="btn" size="small" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
                </div>

                <el-table ref="childTable" border :data="form.details" tooltip-effect="dark" style="width: auto;margin: 0 10px;" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
                    <el-table-column type="selection" fixed width="55">
                    </el-table-column>
                    <el-table-column prop="supplierName" label="供应商">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.supplierName" :disabled="!editMode" placeholder="请选择供应商" :filter-method="getSuppliers" filterable @change="supplierChange(scope.row)" style="width:100%">
                                <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="files" label="附件">
                        <template slot-scope="scope">
                            <my-upload :canEdit="!editMode" @filesChange="(fileList) => filesChange(fileList, scope.row)" :isLimitMaxSiz="true" :oldList="scope.row.fileInfos" />
                            <!-- <el-upload multiple :action="uploadAction" :accept="uploadFileType" :headers="uploadHeaders" :on-preview="openImageViewer" :limit="3" :file-list="scope.row.fileInfos" :on-remove="(file, fileList) => onUploadremove(scope, {file, fileList})" :on-success="(response, file, fileList) => onUploadSuccess(scope, {response, file, fileList})">
                  <el-button class="btn default" size="small">点击上传</el-button>
                </el-upload> -->

                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注">
                        <template slot-scope="scope">
                            <el-input :disabled="!editMode" v-model="scope.row.remark"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
                <my-button class="btn primary" type="primary" size="small" v-if="editMode" v-preventReClick @click="submit">确 定</my-button>
            </div>
        </el-dialog>

        <!-- <el-image-viewer :openViewer="openViewer" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" /> -->
    </div>
    <div class="pagination">
        <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
        </el-pagination>
    </div>
</div>
</template>

<script>
import {
    SaveProductRegistCert,
    GetProductRegistCerts,
    GetProductRegistCertById,
    RemoveProductRegistCerts,
} from "@/api";
import {
  WarehouseTypeOptions,
} from "@/enum";
import GetDataMixin from "@/mixin/getData-mixin.js";
// import ElImageViewer from '@/components/elImageViewer'
import MyUpload from "@/components/my-upload";

export default {
    mixins: [GetDataMixin],
    components: {
        MyUpload,
    },
    data() {
        return {
            WarehouseTypeOptions:WarehouseTypeOptions,
            // 查询条件
            query: {
                keyWord: "",
                pageSize: 10,
                pageIndex: 1,
                sourceType: 1
            },
            // 列表数据
            tableData: [],
            // 列表总数
            total: 0,
            // 弹出框标题
            title: "",
            // 弹出编辑框
            open: false,
            editMode: false,
            // 新增、编辑的数据
            form: {},
            // 多选框数据
            ids: [],
            multipleSelection: [],
            // 列表多选
            multiple: true,
            // 子表
            childIds: [],
            childMultipleSelection: [],
            childMultiple: true,
            rules: {
                sourceType: [{
                    required: true,
                    message: "请选择注册证分类",
                    trigger: "blur"
                }],
                no: [{
                    required: true,
                    message: "请输入编码",
                    trigger: "blur"
                }],
                name: [{
                    required: true,
                    message: "请输入名称",
                    trigger: "blur"
                }],
                manufacturerId: [{
                    required: true,
                    message: "请选择生产厂家",
                    trigger: "blur"
                }, ],
            },
            cancelButtonText: "禁用",
            systemType: [
            {
              id: 1,
              name: "耗材",
            },
            {
              id: 2,
              name: "药品",
            }
          ],
            // 导入上传的文件
            // fileInfos: [],
            // fileId: 0,
            // fileName: '',
            // openViewer: false,
        };
    },
    methods: {
        handleSelectionChange(selection) {
            this.multipleSelection = selection;
            this.ids = selection.map((item) => item.id);
            this.multiple = !selection.length;
        },
        // 获取列表
        getData() {
            GetProductRegistCerts(this.query).then((res) => {
                this.tableData = res.returnData.data;
                this.total = res.returnData.totalCount;
            });
        },
        // 新建
        handleAdd() {
            this.open = true;
            this.title = "新建";
            this.resetForm();
            this.editMode = true;
        },
        handleInfo(row) {
            GetProductRegistCertById({
                id: row.id
            }).then((res) => {
                // this.resetForm();
                this.form = res.returnData;
                this.form.manageRangeIds = this.form.manageRangeIds ?
                    this.form.manageRangeIds.split(";").map((item) => {
                        return item * 1;
                    }) : [];
                if (res.returnData.manageRangeInfos) {
                    res.returnData.manageRangeInfos.map((range) => {
                        let arr = this.STATIC_ManageRanges.filter((e) => e.id == range.id);
                        if (!arr || arr.length == 0) {
                            this.STATIC_ManageRanges.push(range);
                        }
                    });
                }
                this.form.longTime = res.returnData.longTime == 1 ? true : false;

                // this.title = "编辑";
                this.editMode = false;
                this.form.details.forEach((e, index) => {
                    e.$index = index + 1;
                });
                setTimeout(() => {
                    this.open = true;
                }, 300)

            });
        },

        // 编辑
        handleUpdate(row) {
            GetProductRegistCertById({
                id: row.id
            }).then((res) => {
                this.resetForm();
                this.form = res.returnData;
                this.form.manageRangeIds = this.form.manageRangeIds ?
                    this.form.manageRangeIds.split(";").map((item) => {
                        return item * 1;
                    }) : [];
                if (res.returnData.manageRangeInfos) {
                    res.returnData.manageRangeInfos.map((range) => {
                        let arr = this.STATIC_ManageRanges.filter((e) => e.id == range.id);
                        if (!arr || arr.length == 0) {
                            this.STATIC_ManageRanges.push(range);
                        }
                    });
                }
                this.form.longTime = res.returnData.longTime == 1 ? true : false;
                this.open = true;
                this.title = "编辑";
                this.editMode = true;
                this.form.details.forEach((e, index) => {
                    e.$index = index + 1;
                });
            });
        },
        // 保存
        submit() {
            if (!this.form.longTime && !this.form.invalidDate) {
                this.$message.error('失效日期和长期必须选一个');
                return
            }
            this.$refs["form"].validate((valid) => {
                if (!valid) {
                    return false;
                }

                this.form.manageRangeIds = this.form.manageRangeIds ?
                    this.form.manageRangeIds.join(";") :
                    "";
                this.form.longTime = this.form.longTime == true ? 1 : 0
                SaveProductRegistCert(this.form)
                    .then((res) => {
                        // if (res.successful == false) {
                        //   this.$my_message(res.errorMessage,"error")
                        //   return;
                        // }
                        this.open = false;
                        this.$my_message(`执行成功`, "success");
                        this.getData();
                    })
                    .finally((res) => {
                        this.form.manageRangeIds = this.form.manageRangeIds ?
                            this.form.manageRangeIds.split(";").map((item) => {
                                return item * 1;
                            }) : [];
                    });
            });
        },
        resetForm() {
            this.form = {
                name: "",
                details: [],
                sourceType:[1],
                orgCode :sessionStorage.getItem('orgId'),
            };
        },
        // 取消编辑部门
        cancel() {
            if (this.editMode) {
                this.$my_confirm("确认要中断当前操作吗？", "提示", {
                        type: "warning",
                    })
                    .then(() => {
                        this.open = false;
                    })
                    .catch(() => {});
            } else {
                this.open = false;
            }
        },
        // 改变当前页
        changePage(val) {
            this.$set(this.query, "pageIndex", val);
            this.getData();
        },
        handleSizeChange(val) {
            this.$set(this.query, "pageSize", val);
            this.getData();
        },

        // 删除部门
        handleDelete(row) {
            const ids = row && row.id ? [row.id] : this.ids;

            this.$my_confirm("此操作将删除数据, 是否继续?", "提示", {
                    type: "warning",
                })
                .then(() => {
                    return RemoveProductRegistCerts({
                        ids
                    });
                })
                .then(() => {
                    this.$my_message(`删除成功`, "success");
                    this.getData();
                })
                .catch(() => {});
        },
        // 重置
        reset() {
            this.query.keyWord = "";
            this.$set(this.query, "pageIndex", 1);
            this.$set(this.query, "pageSize", 10);
            this.ids = []
            this.multipleSelection = []
            this.multiple = true;
            this.query.sourceType = 1;
            if (this.$refs.multipleTable) {
                this.$refs.multipleTable.clearSelection()
            }
            this.getData();
        },
        queryChange() {
            this.$set(this.query, "pageIndex", 1);
            this.getData();
        },
        handleAddChildForm() {
            if (!this.form.details) this.form.details = [];
            this.form.details.push({
                $index: this.form.details.length + 1,
                id: 0,
                supplierId: "",
                supplierName: "",
                remark: "",
            });
        },
        handleDeleteChildForm() {
            this.form.details = this.form.details.filter(
                (i) => !this.childIds.includes(i.$index)
            );
            this.form.details.forEach((e, index) => {
                e.$index = index + 1;
            });
        },
        handleChildSelectionChange(selection) {
            this.childMultipleSelection = selection;
            this.childIds = selection.map((item) => item.$index);
            this.childMultiple = !selection.length;
        },
        manufacturerChange(val) {
            this.form.manufacturerId = val;
        },
        registrantUserChange(val) {
            this.form.registrantUser = val;
        },
        AgentNameChange(val){
          this.form.agentId = val
        },
        manageRangeChange(val) {
            // this.form.leader = val
        },
        supplierChange(row) {
            row.supplierId = row.supplierName;
        },
        invalidDateEvt(val) {
            this.form.invalidDate = val
            this.form.longTime = false;
            this.$forceUpdate()
        },
        longTimeEvt(boolean) {
            if (boolean == true) {
                this.form.invalidDate = null;
            }
            this.$forceUpdate()
        },
        // 上传附件
        filesChange(fileList, row) {
            row.fileInfos = fileList;
        },
        // openImageViewer (e) {
        //   this.openViewer = true;
        //   this.fileId = e.id
        //   this.fileName = e.name
        // },
        // closeImageViewer () {
        //   this.openViewer = false;
        // },
        // // 当上传完文件以后
        // onUploadSuccess (scope, e) {
        //   if (!scope.row.fileInfos) {
        //     scope.row.fileInfos = [];
        //   }
        //   scope.row.fileInfos.push(...e.response.returnData);
        //   scope.row.files = scope.row.fileInfos.map(e => e.id).join(';')
        // },
        // // 删除文件以后
        // onUploadremove (scope, e) {
        //   scope.row.fileInfos = [...e.fileList];
        //   scope.row.files = scope.row.fileInfos.map(e => e.id).join(';')
        // },
        tabClick() {
          this.getData();
        },
    },
    mounted() {
        this.getData();
        this.getManufacturers("", 1);
        this.getManageRanges("");
        this.getSuppliers("");
    },
};
</script>

<style lang="scss" scoped>
.manageRange {
    width: 100%;
    max-height: 120px;
    overflow-x: hidden;

    /deep/.el-select__tags {
        max-height: 120px !important;
    }
}

.oldProduction {}
</style>
